export default __webpack_public_path__ + "static/media/sticker-q.4c0e49b3.png";